import React from "react";
import PropTypes from "prop-types";

import LanguageSelector from "common/LanguageSelector";
import { staticURL } from "lib/img";
import { formatPhone } from "lib/util";
import { WORKFORCE_ALWAYS_ON_PHONE } from "lib/constants";

export default function LandingPage(props, { t: _ }) {
    return (
        <div className="flex flex-col flex-jsb h100">
            <div className="check-in">
                <div className="check-in__questions">
                    <div className="portal-card-group questions__card-group">
                        <div className="check-in__landing-page">
                            <div className="check-in__landing-page-image-container">
                                <img
                                    src={staticURL("always-on-qr-code.svg")}
                                    className="always-on-qr"
                                    alt=""
                                />
                            </div>
                            <div className="check-in__landing-page-content">
                                <h2 className="check-in__landing-page-title">
                                    {_("Have some feedback you'd like to share?")}
                                </h2>
                                {/* eslint-disable react/no-danger */}
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: _(
                                            "Text '{smsCode}' to {smsPhoneNumber} or scan the QR code to get started.",
                                            {
                                                smsCode: `<a className="always-on-link" href="SMSTO:${WORKFORCE_ALWAYS_ON_PHONE}:FEEDBACK">FEEDBACK</a>`,
                                                smsPhoneNumber: formatPhone(
                                                    WORKFORCE_ALWAYS_ON_PHONE.substring(2),
                                                ),
                                            },
                                        ),
                                    }}
                                />
                                {/* eslint-enable */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <LanguageSelector />
        </div>
    );
}

LandingPage.contextTypes = {
    t: PropTypes.func,
};
